export enum DEPOSIT_TYPE {
  Checks = 1,
  CreditCard,
  Cash,
}

export enum PAYMENT_TYPE {
  Cash = 1,
  Checks,
  CreditCard,
  Transfer,
}

export enum DEPOSIT_ACTIONS {
  Show = 1,
  Create,
}
